import { Box, Grid, Typography } from '@material-ui/core';
import SubscriptionList from '../../../subscriptionInfo/components/subscriptionList';
import { formatDateString } from '../../../utils/common';
import { useTranslation } from 'react-i18next';
import LocaleKeys from '../../../locales/keys';

const NewSubscription = (props) => {
  const {
    classes,
    thumbnailUrl,
    subscriptionStartDate,
    newSubscriptionAmount,
    newGrossAmount,
    hasDiscount,
    renewalDate,
    billCycleText,
  } = props;
  const { t } = useTranslation();

  return (
    <Grid item container>
      <Grid item container>
        <Grid item>
          <Box
            p={2}
            style={{
              backgroundColor: '#E6F854',
              marginBottom: '16px',
              borderRadius: '4px',
            }}
          >
            <Typography
              style={{
                color: '#000000',
                fontSize: '14px',
                fontWeight: '700',
                letterSpacing: '0.5%',
                WebkitFontSmoothing: 'auto',
                textTransform: 'uppercase',
              }}
            >
              {t(LocaleKeys.subscriptionInfo.subscriptions.upgrade)}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid item xs={12} lg={6} className={classes.reviewOrderDetailsImage}>
        <img
          style={{ height: '25px' }}
          src={thumbnailUrl}
          alt="order-summary-product-thumbnail"
        />
      </Grid>
      <Grid item container style={{ flexDirection: 'column' }}>
        <Grid item>
          <SubscriptionList
            classes={classes}
            name={`${t(
              LocaleKeys.subscriptionInfo.subscriptions.subscriptionStartDate,
            )}:`}
            value={formatDateString(subscriptionStartDate)}
            key={'subscriptionStartDate'}
          />
        </Grid>
        <Grid item>
          <SubscriptionList
            classes={classes}
            hasDiscount={hasDiscount ? newGrossAmount : null}
            name={`${t(
              LocaleKeys.subscriptionInfo.subscriptions.newSubscriptionAmount,
            )}:`}
            value={newSubscriptionAmount}
            key={'newSubscriptionAmount'}
          />
        </Grid>
        <Grid item>
          <SubscriptionList
            classes={classes}
            name={`${t(
              LocaleKeys.payment.orders.subscriptionQuoteRenewalCycle,
            )}:`}
            value={billCycleText}
            key={'subscriptionQuoteRenewalCycle'}
          />
        </Grid>
        <Grid item>
          <SubscriptionList
            classes={classes}
            name={`${t(
              LocaleKeys.subscriptionInfo.subscriptions
                .subscriptionItemRenewalDate,
            )}:`}
            value={formatDateString(renewalDate)}
            key={'renewalDate'}
          />
        </Grid>
        <Grid item>
          <SubscriptionList
            classes={classes}
            name={`${t(
              LocaleKeys.subscriptionInfo.subscriptions
                .subscriptionItemRenewalAmount,
            )}:`}
            value={newGrossAmount}
            key={'renewalDate'}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default NewSubscription;
